import { StatusType } from '../../../order.types';
import { ForceSyncOrderStatusRule } from './force-sync-order-status-rule.interface';
import { AbandonedForceSyncRule } from './rules/abandoned-force-sync.rule';
import { ApprovedForceSyncRule } from './rules/approved-force-sync.rule';
import { CanceledForceSyncRule } from './rules/canceled-force-sync.rule';
import { DraftForceSyncRule } from './rules/draft-force-sync.rule';
import { InRevisionForceSyncRule } from './rules/in-revision-force-sync.rule';
import { OnApprovalForceSyncRule } from './rules/on-approval-force-sync.rule';
import { RejectedForceSyncRule } from './rules/rejected-force-sync.rule';
import { SentForceSyncRule } from './rules/sent-force-sync.rule';
import { SuggestedForceSyncRule } from './rules/suggested-force-sync.rule';

export class ForceSyncOrderStatusValidator {
  static showForceSync(params: ForceSyncOrderStatusRule & { orderStatus?: StatusType }): boolean {
    switch (params.orderStatus) {
      case StatusType.ABANDONED:
        return new AbandonedForceSyncRule().showForceSync();

      case StatusType.CANCELED:
        return new CanceledForceSyncRule().showForceSync();

      case StatusType.SUGGESTED:
        return new SuggestedForceSyncRule().showForceSync();

      case StatusType.DRAFT:
        return new DraftForceSyncRule().showForceSync();

      case StatusType.IN_REVISION:
        return new InRevisionForceSyncRule().showForceSync();

      case StatusType.ON_APPROVAL:
        return new OnApprovalForceSyncRule().showForceSync(params);

      case StatusType.APPROVED:
        return new ApprovedForceSyncRule().showForceSync(params);

      case StatusType.REJECTED:
        return new RejectedForceSyncRule().showForceSync();

      default:
        return new SentForceSyncRule().showForceSync(params);
    }
  }
}
